module.exports = __webpack_public_path__ + "dd50a5562278f0d3cb0b9e831d12afe6.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_4_circ.mp3
 ** module id = 179
 ** module chunks = 0
 **/